const tabs = [
  "Demographics",
  "Location",
  "Agriculture",
  "Education",
  "Resources",
  "Safeguarding",
];

const AnalyticsTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-2 w-full overflow-x-auto justify-center flex ">
      <div className="flex gap-2 min-w-max">
        {tabs.map((tab) => {
          const isActive = activeTab === tab;

          return (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`
                px-5 py-2 rounded-lg text-sm font-medium whitespace-nowrap
                transition-all duration-200
                ${
                  isActive
                    ? "bg-yellow-400 text-green-900 shadow-sm"
                    : "text-gray-600 hover:bg-gray-100"
                }
              `}
            >
              {tab}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AnalyticsTabs;
